import Container from "@material-ui/core/Container";
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import FromMain from "./from-main-menu.js";
const theme = createMuiTheme({
	overrides: {
	  MuiCssBaseline: {
		'@global': {
		  body: {
			backgroundColor: '#716f6f',
		  },
		},
	  },
	},
	palette: {
		primary:{
			main: '#305e82',
		  }, 
	  }
  });
function MainFrom () {
	
		return (
			<ThemeProvider theme={theme}>
			<div >
				<div className="login-cover-image"></div>
				<CssBaseline />
				<Container direction="row">
					<FromMain />
				</Container>
			</div>
			</ThemeProvider>
		);
	
}

export default MainFrom;
